import Cnt from './components/Cnt';
import msg from './msg';
import pl from '../releases/pl.json';

export default function cnt(locale: typeof pl, paths: string, values?: Record<string, any>): JSX.Element {
  const message = msg(locale, paths, values);

  return <Cnt content={message} />;
}
